<template>
  <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" :refresh="false" :current-page="currentPage" ref="table" :isAddPageToRouter="isAddPageToRouter" :isOutside="isOutside">
    <base-table :class="$style['pt-lab-product-table']" :table-data="tableData" :columns="tableLabels" :selectType="selectType" :row-key="getRowKeys" :selectedKeys="selectedKeys" @selection-change="handleSelectionChange">
      <template slot="examBasisName" slot-scope="scope" v-if="isDialog">
        <wt-input v-model="scope.row.examBasis.name"></wt-input>
      </template>
      <template slot="deviate" slot-scope="scope" v-if="isDialog">
        <el-select v-model="scope.row.deviate" placeholder="请选择是否有偏离">
          <el-option label="是" :value="true"></el-option>
          <el-option label="否" :value="false"></el-option>
        </el-select>
      </template>
      <template slot="deviateInfo" slot-scope="scope" v-if="isDialog">
        <wt-input v-model="scope.row.deviateInfo"></wt-input>
      </template>
      <template slot="attachments" slot-scope="scope" v-if="isDialog">
        <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl" listType="text" v-model="scope.row.attachments" :class="$style['dialog-upload']">
          <el-button size="small" type="primary">点击上传</el-button>
        </wt-upload-file>
      </template>
      <template slot="operate" slot-scope="scope">
        <el-button type="text" @click="goProductDetail(scope.row.id)">详情</el-button>
      </template>
    </base-table>
  </wt-paged-table>
</template>

<script>
import { tableLabels } from 'cps/lab-product/pt-lab-product/lab-product-option.js'
// 组件class前缀
const prefixCls = 'pt-lab-product-table'

export default {
  name: 'pt-lab-product-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    },
    tableLabels () {
      let hasDeviate = false
      let hasDeviateInfo = false
      let hasAttachments = false
      tableLabels.forEach((item, index) => {
        if (item.label === '检测依据' && this.isDialog) {
          item.slotName = 'examBasisName'
        }
        if (item.label === '是否有偏离') {
          hasDeviate = true
        }
        if (item.label === '偏离原因') {
          hasDeviateInfo = true
        }
        if (item.label === '相关文献') {
          hasAttachments = true
        }
      })
      let newTableLabels = tableLabels
      if (this.isDialog) {
        if (!hasDeviate) {
          tableLabels.push(
            {
              label: '是否有偏离',
              slotName: 'deviate',
              minWidth: '180px'
            })
        }
        if (!hasDeviateInfo) {
          tableLabels.push({
            label: '偏离原因',
            slotName: 'deviateInfo',
            minWidth: '150px'
          })
        }
        if (!hasAttachments) {
          tableLabels.push({
            label: '相关文献',
            slotName: 'attachments',
            minWidth: '150px'
          })
        }
      } else {
        tableLabels.forEach((item, index) => {
          if (item.label === '检测依据') {
            this.$delete(item, 'slotName')
          }
        })
        newTableLabels = tableLabels.filter(item => {
          return !item.slotName || item.slotName === 'operate'
        })
      }
      return newTableLabels
    }
  },
  watch: {
    tableData: {
      handler: function(val){
        val.forEach(item => {
          item.attachments=item.attachments||[]
        })
      },
      immediate: true
    }
  },
  props: {
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 0
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    selectType: {
      type: String,
      default: ''
    },
    selectedKeys: {
      type: [String, Array],
      default: ''
    },
    isDialog: Boolean,
    isAddPageToRouter: Boolean,
  },
  data () {
    return {
      privateResourcesUrl: this.$privateResourcesUrl,
      uploadApi: this.$uploadApi,
      picture_params: {
        resourceName: 'literature',
        objectId: this.value?.id || 0
      }
      // tableLabels
    }
  },
  methods: {
    goProductDetail (id) {
      this.$router.push(`/lab-product-detail/${id}`)
    },
    getRowKeys (row) {
      return row.id
    },
    handleSelectionChange (val) {
      this.$emit('selection-change', val)
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    showReTry () {
      this.$refs.table.showReTry()
    },
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    },
    load () {
      this.$refs.table.load()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-lab-product-table{
	:global{
		.el-input__inner{
			padding: 0 0!important;
		}
		.el-input--suffix .el-input__inner{
			min-width: 1.5rem!important;
			padding: 0 .1rem
		}
	}
}
</style>
